import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { TwitterKeywords } from 'src/app/models/period-aggregate-amounts.model'
import { getTwitterKeywords, getLoading } from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByTwitterKeywords,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-twitter-keywords-count',
    templateUrl: './aggregated-amounts-twitter-keywords-count.component.html',
    styleUrls: ['./aggregated-amounts-twitter-keywords-count.component.scss'],
    standalone: false
})
export class AggregatedAmountsTwitterKeywordsCountComponent implements OnInit {
  twitterKeywordsCountModel$: Observable<TwitterKeywords>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.twitterKeywordsCountModel$ = this.store.select(getTwitterKeywords)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByTwitterKeywords)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
